import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sscSanxingWeishu'
})
export class SscSanxingWeishuPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    let lottery_arr = [];
    // 尾数
    let num: number;

    switch (args) {
      case 'qiansan':
        value.forEach((element, index) => {
          if (index < 3) {
            lottery_arr.push(Number(element));
          }
          num = this.calculation_num_handler(lottery_arr);
        });
        break;
      case 'zhongsan':
        value.forEach((element, index) => {
          if (index > 0 && index < 4) {
            lottery_arr.push(Number(element));
          }
          num = this.calculation_num_handler(lottery_arr);
        });
        break;
      case 'housan':
        value.forEach((element, index) => {
          if (index > 1) {
            lottery_arr.push(Number(element));
          }
          num = this.calculation_num_handler(lottery_arr);
        });
        break;
      default: break;
    }

    return num;
  }

  private calculation_num_handler(lottery_arr: any): number {
    let total: number = 0;
    lottery_arr.forEach(element => {
      total += element;
    });

    let n: number = total % 10;
    return n;
  }

}
